import {
  AccessDeniedError, CoreConfig, JwtUtil, Person, UserModel
} from './../../common';

export class JwtStorage {
  constructor( private config: CoreConfig ) { }

  get(): string | null { return window.sessionStorage.getItem(this.config.auth.tokenName); }

  set(value: string) {
    // If the JWT parses correctly assume it is valid
    JwtUtil.parse(value);

    window.sessionStorage.removeItem('loginAttempts');
    window.sessionStorage.setItem(this.config.auth.tokenName, value);
  }

  clear() { window.sessionStorage.removeItem(this.config.auth.tokenName); }

  login() {
    const loginAttempts = parseInt(window.sessionStorage.getItem('loginAttempts') || '0', 10);

    window.sessionStorage.setItem('loginAttempts', (loginAttempts + 1).toString());

    if (loginAttempts > 3) {
      throw new AccessDeniedError('Too many login attempts: ' + loginAttempts);
    }

    window.sessionStorage.setItem(`${this.config.appName}_ORIGINAL_URL_KEY`, window.location.href);

    window.location.assign(this.config.auth.loginUrl as string);
  }

  currentUser(): Person | null {
    const jwt = this.get();

    if (!jwt) {
      return null;
    }

    const payload = JwtUtil.parse(jwt);

    return UserModel.create(payload.user) as Person;
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/auth/JwtStorage.ts